import { useReactiveVar } from '@apollo/client/react';
import { without } from 'lodash';
import React from 'react';

import CreateEventModal from '../Events/CreateEventModal';
import CreateNoteModal from '../Notes/CreateNoteModal';
import CreateProjectModal from '../Projects/CreateProjectModal';
import EditReportModal from '../Reports/EditReportModal';
import ViewReportModal from '../Reports/ViewReportModal';
import CreateTaskModal from '../Tasks/CreateTaskModal';

import CreateKickoffModal from '@/components/KickOffs/CreateModal';
import RightDrawer from '@/components/RightDrawer';
import KickOffContextProvider from '@/Contexts/KickOff/Provider';
import ProjectContextProvider from '@/Contexts/Project/Provider';
import ReportContextProvider from '@/Contexts/ReportContext/Provider';
import { setOpenedModals } from '@/graphql/reactiveVars';
import { DRAWER_WIDTH } from '@/utils/constants';

const ControlledModals: React.FC = () => {
  const openedModals = useReactiveVar(setOpenedModals);
  const isDrawerOpen = openedModals.includes('Note') || openedModals.includes('Tasks');

  const handleDrawerClose = () => {
    setOpenedModals(without(openedModals, 'Note', 'Tasks'));
  };

  const currentContentType = openedModals.includes('Note') ? 'Notes' : openedModals.includes('Tasks') ? 'Tasks' : null;

  return (
    <React.Fragment>
      {currentContentType && (
        <RightDrawer
          open={isDrawerOpen}
          onClose={handleDrawerClose}
          drawerContentType={currentContentType}
          sx={{
            width: DRAWER_WIDTH,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: DRAWER_WIDTH,
            },
          }}
        />
      )}

      {openedModals.includes('CreateEvent') && (
        <CreateEventModal minimized={false} handleClose={() => setOpenedModals(without(openedModals, 'CreateEvent'))} />
      )}
      {openedModals.includes('EditReport') && (
        <EditReportModal minimized={false} handleClose={() => setOpenedModals(without(openedModals, 'EditReport'))} />
      )}
      {openedModals.includes('ViewReport') && (
        <ReportContextProvider>
          <ViewReportModal minimized={false} handleClose={() => setOpenedModals(without(openedModals, 'ViewReport'))} />
        </ReportContextProvider>
      )}
      {openedModals.includes('CreateTask') && (
        <CreateTaskModal minimized={false} handleClose={() => setOpenedModals(without(openedModals, 'CreateTask'))} />
      )}
      {openedModals.includes('CreateNote') && (
        <CreateNoteModal minimized={false} handleClose={() => setOpenedModals(without(openedModals, 'CreateNote'))} />
      )}
      {openedModals.includes('CreateProject') && (
        <ProjectContextProvider>
          <CreateProjectModal
            minimized={false}
            handleClose={() => setOpenedModals(without(openedModals, 'CreateProject'))}
          />
        </ProjectContextProvider>
      )}
      {openedModals.includes('KickOff') && (
        <KickOffContextProvider>
          <CreateKickoffModal
            minimized={false}
            handleClose={() => {
              // const spider = document.getElementById('action-spider')
              // if (spider) {
              //   spider.style.visibility = "visible"
              // }
              setOpenedModals(without(openedModals, 'KickOff'));
            }}
          />
        </KickOffContextProvider>
      )}
    </React.Fragment>
  );
};

export default ControlledModals;
